const perks = [
  'Priority placement in all search results',
  'Premium villa profile with extended content',
  'Zero platform commission during launch period',
  'Access to our coach booking network from day one',
  'Dedicated account manager during onboarding',
  'Founding Partner badge on your villa listing',
];

export default function EarlyPartner() {
  return (
    <section id="early-partner" className="relative py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/6b6706c8d95528f5f4d0762db85271f8.jpg"
          alt="Illuminated luxury villa at night"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/50" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 border border-[#D4845C]/60 text-[#D4845C] text-xs font-inter font-medium tracking-[0.15em] uppercase px-4 py-2 rounded-full mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#D4845C] inline-block" />
            Limited Founding Partners
          </div>

          <h2 className="font-cormorant text-5xl lg:text-7xl font-light text-white leading-[1.05] mb-6">
            Be Among<br />
            <em className="italic text-[#C9A86A]">the First Fifty.</em>
          </h2>

          <p className="font-inter font-light text-white/70 text-base leading-relaxed mb-10 max-w-lg">
            PadelVillas is accepting a strictly limited cohort of Founding Partners. Those who join now carry permanent advantages that define their visibility on the platform for good. Spots are limited and will not reopen once filled.
          </p>

          {/* Perks list */}
          <ul className="space-y-3 mb-12">
            {perks.map((perk) => (
              <li key={perk} className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#C9A86A] text-sm font-bold" />
                </div>
                <span className="font-inter font-light text-white/80 text-sm">{perk}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap items-center gap-4">
            <button
              onClick={() => {
                const el = document.getElementById('lead-form');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="whitespace-nowrap bg-[#D4845C] text-white font-inter font-medium text-sm px-8 py-4 rounded-full hover:bg-[#c4734b] transition-all duration-200 cursor-pointer flex items-center gap-2"
            >
              Secure Your Founding Spot
              <i className="ri-arrow-down-line" />
            </button>
            <span className="font-inter text-xs text-white/40">Only 50 founding partners accepted</span>
          </div>
        </div>
      </div>
    </section>
  );
}
